import OpenChatButtonAdapter from "./OpenChatButton";

export { OpenChatButtonAdapter as OpenChatButton };
